module.exports = __webpack_public_path__ + "static/P2101555-4db7d082b156120f2a5d16d3c877de14.jpg";